// extracted by mini-css-extract-plugin
export default {"t":"Toggle_t__7qW-V","t_icon":"Toggle_t_icon__SI0TB","t_button":"Toggle_t_button__ySXxQ"};